import {LanguageId} from './languageManifest';

export const DEFAULT_LANGUAGE_ID: LanguageId = `en-US`;
